var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6 5.79961H14V4.19961C14 3.97961 13.82 3.79961 13.6 3.79961H12.8C12.58 3.79961 12.4 3.97961 12.4 4.19961V5.79961H10.8C10.58 5.79961 10.4 5.97961 10.4 6.19961V6.99961C10.4 7.21961 10.58 7.39961 10.8 7.39961H12.4V8.99961C12.4 9.21961 12.58 9.39961 12.8 9.39961H13.6C13.82 9.39961 14 9.21961 14 8.99961V7.39961H15.6C15.82 7.39961 16 7.21961 16 6.99961V6.19961C16 5.97961 15.82 5.79961 15.6 5.79961ZM5.6 6.99961C7.3675 6.99961 8.8 5.56711 8.8 3.79961C8.8 2.03211 7.3675 0.599609 5.6 0.599609C3.8325 0.599609 2.4 2.03211 2.4 3.79961C2.4 5.56711 3.8325 6.99961 5.6 6.99961ZM7.84 7.79961H7.4225C6.8675 8.05461 6.25 8.19961 5.6 8.19961C4.95 8.19961 4.335 8.05461 3.7775 7.79961H3.36C1.505 7.79961 0 9.30461 0 11.1596V12.1996C0 12.8621 0.5375 13.3996 1.2 13.3996H10C10.6625 13.3996 11.2 12.8621 11.2 12.1996V11.1596C11.2 9.30461 9.695 7.79961 7.84 7.79961Z",
    fill: "#F2994A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPerson);
export default __webpack_public_path__ + "static/media/add-person.5b310d22840719a8f04539b82ceb3b82.svg";
export { ForwardRef as ReactComponent };